import { Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { SmService } from '../../../pages/sm/services/sm.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { SmSharedService } from '../../../pages/sm/services/sm-shared.service';

@Component({
  selector: 'app-ready-to-complete',
  templateUrl: './ready-to-complete.component.html',
  styleUrl: './ready-to-complete.component.css'
})
export class ReadyToCompleteComponent implements OnInit {
  formData: any = {};
  selectedTrip: any;
  constructor(private ngbActiveModal: NgbActiveModal, private smService: SmService, public smDataService: SmDataService, private smSharedService: SmSharedService) {

  }

  ngOnInit() {
    this.formData = {};
    this.selectedTrip = null;
  }

  public selecteTrip(data) {
    this.resetSelected();
    data.selected = true;
    this.selectedTrip = data;
  }

  public completeClicked() {
    this.resetSelected();
    this.ngbActiveModal.close(this.selectedTrip);
  }

  public cancelClicked() {
    this.resetSelected();
    this.ngbActiveModal.dismiss();
  }

  private resetSelected() {
    this.smDataService.readyToCompleteList.forEach((val: any) => {
      val.selected = false;
    })
  }
}
